export default String.raw`
{% assign incSplit = inc | Split:'|' -%}
{% assign daId = incSplit[0] | ToInt -%}
{% assign da = customer.DeliveryAddresses[daId] -%}

{% if settings.blockAddingAndEditingDeliveryAddress == 'no' -%}
	{% assign canEditOrAddDeliveryAddress = true -%}
{% elseif settings.blockAddingAndEditingDeliveryAddressFor == 'withLimits' and customer.CreditLimit == null -%}
	{% assign canEditOrAddDeliveryAddress = true -%}
{% endif -%}

<div class="customer-info">
	{% if da.Default -%}
	<div class="customer-info__header">
	{% if da.Default -%}
		<div class="default">{{ translations.AddressDefault }}</div>
	{% endif -%}
	{% if canEditOrAddDeliveryAddress -%}
		{% if da.Default -%}
		<div class="address-popup-js"></div>
		<button class="pure-button set-focus-trap-js replace-template-js opening-modal-mobile-js" data-template="partials/customer-profile/customer-details/deliv-adres-form.html" data-container=".address-popup-js" data-include="{{inc}}">
			{{ translations.Edit }}
		</button>
		{% endif -%}
	{% endif -%}
	</div>
	{% endif -%}
	<div class="customer-info__title">
	{% if da.Default -%}
		<strong>{{ da.Name }}{{ da.Name2 }}</strong>
	{% else -%}
		<strong>{{ da.Name }}{{ da.Name2 }}</strong>
	{% endif -%}
	{% if da.Default == false -%}
		<div class="dropdown-wrapper">
			<button class="pure-button open-dropdown-js">
				<svg width="24" height="24" style="transform: rotate(90deg);">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ellipsis-h-{{settings.iconStyle}}"></use>
				</svg>
			</button>
			<div class="dropdown dropdown-js hidden-js">
				<div class="form-js form-into-data-js">
					{% if da.Default -%}
						{{ translations.AddressDefault }}
					{% else -%}
						<button class="pure-button post-js replace-template-js" data-container=".delivery-addresses-container-js" data-template="partials/customer-profile/customer-details/deliv-addresses.html">
							{{ translations.SetAsDefault }}
						</button>
						<input type="hidden" name="default" value="true">
					{% endif -%}
					<input type="hidden" name="addressId" value="{{ da.Id }}" >
					<input type="hidden" name="name" value="{{ da.Name | H }}">
					<input type="hidden" name="street" value="{{ da.Street | H }}">
					<input type="hidden" name="streetNo" value="{{ da.StreetNo }}">
					<input type="hidden" name="unitNo" value="{{ da.UnitNo }}" >
					<input type="hidden" name="zipCode" value="{{ da.ZipCode }}">
					<input type="hidden" name="city" value="{{ da.City | H }}">
					<input type="hidden" name="countryCode" value="{{ da.Country }}">
					<input type="hidden" name="phoneNo" value="{{ da.PhoneNo }}">
					<input type="hidden" name="__action" value="Customer/DeliveryAddressUpdate" >
				</div>
				<div class="form-js form-into-data-js">
					{% if canEditOrAddDeliveryAddress -%}
					<input type="hidden" name="__action" value="Customer/DeliveryAddressDelete" >
					<input type="hidden" name="addressId" value="{{ da.Id }}" >
					<button class="pure-button delete-js" data-container=".delivery-addresses-container-js" data-template="partials/customer-profile/customer-details/deliv-addresses.html" data-container=".delivery-addresses-container-js">
						{{ translations.Delete }}
					</button>
					{% endif -%}
				</div>
				{% if canEditOrAddDeliveryAddress -%}
				<button class="pure-button set-focus-trap-js replace-template-js opening-modal-mobile-js" data-template="partials/customer-profile/customer-details/deliv-adres-form.html" data-container=".address-popup-js" data-include="{{inc}}">
					{{ translations.Edit }}
				</button>
				{% endif -%}
			</div>
		</div>
	{% endif -%}
	</div>
	<div class="customer-info__container">
		<div class="customer-info__content">
			<div class="title">{{ translations.Address }}</div>
			<span>{{ da.Street }} {{ da.StreetNo }}{% if da.UnitNo != '' -%}/{{ da.UnitNo }}{% endif -%}</span>
			<span>{{ da.ZipCode }} {{ da.City }}</span>
			<span>{{ config.Countries[da.Country].Name }}</span>
		</div>
		{% if da.PhoneNo != '' -%}
		<div class="customer-info__content">
			<div class="title">{{ translations.Phone }}</div>
			<span> {{ da.PhoneNo }}</span>
		</div>
		{% endif -%}
	</div>
</div>
`